const Globals = {}

export {Globals}
